export default __webpack_public_path__ + "static/media/eesc-horizontal.b184fa5b.png";